


export class CostReviewLabEquipment {
  numberOfTerminalUnits!: number;
  manufacturer!: string;
  airValvesFurnishedBy!: number;
  airValvesInstalledBy!: number;
  controlsFurnishedBy!: number;
  controlsInstalledBy!: number;
  controlsWiredBy!: number;
  networkType!: number;
  power!: number;
  isLabEquipmentApplicable!: boolean;
}
